<template>
  <router-view/>
</template>
<script>
    export default {
    name: 'falloIndex'
    }
</script>

<style scoped>

</style>
